// ========== HEADER SCROLL (hide on scroll down, reveal on scroll up) ==========
const header = document.getElementById('header');
let lastY = window.scrollY;
let accum = 0; // accumulated scroll distance in the current direction
const HIDE_AFTER = 110;  // must scroll down this far (past the threshold) before hiding
const SHOW_AFTER = 70;   // scroll up this far to bring it back
const onScroll = () => {
  const y = window.scrollY;
  if (y > 60) header.classList.add('scrolled');
  else header.classList.remove('scrolled');

  const dy = y - lastY;
  // reset the accumulator when the scroll direction flips
  if ((dy > 0 && accum < 0) || (dy < 0 && accum > 0)) accum = 0;
  accum += dy;

  if (y > 300 && accum > HIDE_AFTER) {
    header.classList.add('hdr-hidden');
    accum = 0;
  } else if (accum < -SHOW_AFTER || y <= 150) {
    header.classList.remove('hdr-hidden');
    accum = 0;
  }
  lastY = y;
};
window.addEventListener('scroll', onScroll, { passive: true });
onScroll();

// ========== EXCLUSIVE FINDS ACCORDION ==========
const accCards = document.querySelectorAll('.acc-card');
accCards.forEach(card => {
  card.addEventListener('mouseenter', () => {
    accCards.forEach(c => c.classList.remove('active'));
    card.classList.add('active');
  });
});

// ========== COUNTDOWN ==========
const cdEl = document.getElementById('countdown');
let target;
const cdTargetAttr = cdEl && cdEl.dataset.target;
if (cdTargetAttr && !isNaN(Date.parse(cdTargetAttr.replace(' ', 'T')))) {
  target = new Date(cdTargetAttr.replace(' ', 'T'));
} else {
  // Fallback: now + 213d 7h 4m 24s
  target = new Date();
  target.setDate(target.getDate() + 213);
  target.setHours(target.getHours() + 7, target.getMinutes() + 4, target.getSeconds() + 24);
}

const pad = n => String(n).padStart(2, '0');
const elD = document.getElementById('cd-d');
const elH = document.getElementById('cd-h');
const elM = document.getElementById('cd-m');
const elS = document.getElementById('cd-s');

function tick() {
  const diff = target - new Date();
  if (diff <= 0) return;
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff / 3600000) % 24);
  const m = Math.floor((diff / 60000) % 60);
  const s = Math.floor((diff / 1000) % 60);
  if (elD) elD.textContent = d;
  if (elH) elH.textContent = pad(h);
  if (elM) elM.textContent = pad(m);
  if (elS) elS.textContent = pad(s);
}
tick();
setInterval(tick, 1000);

// ========== SIZE BUTTONS ==========
document.querySelectorAll('.sizes').forEach(group => {
  group.addEventListener('click', e => {
    if (e.target.tagName !== 'BUTTON') return;
    group.querySelectorAll('button').forEach(b => b.classList.remove('active'));
    e.target.classList.add('active');
  });
});

// ========== SWATCHES ==========
document.querySelectorAll('.swatches').forEach(group => {
  group.addEventListener('click', e => {
    if (e.target.tagName !== 'SPAN') return;
    group.querySelectorAll('span').forEach(s => s.style.outline = '');
    e.target.style.outline = '2px solid #0a0a0a';
    e.target.style.outlineOffset = '2px';
  });
});

// ========== REVEAL ON SCROLL ==========
const revealEls = document.querySelectorAll(
  '.section, .hero-content, .discover-text, .limited-left'
);
revealEls.forEach(el => el.classList.add('reveal'));
const io = new IntersectionObserver(entries => {
  entries.forEach(en => {
    if (en.isIntersecting) {
      en.target.classList.add('in');
      io.unobserve(en.target);
    }
  });
}, { threshold: 0.12 });
revealEls.forEach(el => io.observe(el));

// ========== MOBILE: eye (quick view) reveals size/colour overlay ==========
// On touch devices there is no hover, so the eye button toggles the overlay.
// On desktop the eye button is hidden via CSS (hover already reveals the overlay).
// Delegated (capture phase) so the eye keeps working after carousels rebuild
// their track HTML for the seamless loop, and after the grid re-renders on filter.
// Capture runs before the button's inline onclick (which stops propagation).
document.addEventListener('click', e => {
  const btn = e.target.closest ? e.target.closest('.quick') : null;
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  const wrap = btn.closest('.d-img, .product-img, .ltd-img') || btn.parentElement;
  const overlay = wrap && wrap.querySelector('.product-overlay');
  if (!overlay) return;
  // close any other open overlays first
  document.querySelectorAll('.product-overlay.show').forEach(o => {
    if (o !== overlay) o.classList.remove('show');
  });
  overlay.classList.toggle('show');
}, true);
// tap outside to close an open overlay
document.addEventListener('click', e => {
  if (e.target.closest('.product-overlay') || e.target.closest('.quick')) return;
  document.querySelectorAll('.product-overlay.show').forEach(o => o.classList.remove('show'));
});
// Guard: never navigate the card image link when the tap is on the quick-view eye
// or inside the colour/size overlay, or while that card's overlay is open (mobile).
// Runs in capture so it beats the anchor's default navigation.
document.addEventListener('click', e => {
  if (!e.target.closest) return;
  const link = e.target.closest('a.product-img, a.d-img, a.ltd-img');
  if (!link) return;
  if (e.target.closest('.quick') || e.target.closest('.product-overlay')) {
    e.preventDefault();
    return;
  }
  const card = link.closest('.product, .d-card, .ltd-card');
  if (card && card.querySelector('.product-overlay.show')) {
    e.preventDefault();
  }
}, true);

// ========== HERO PARALLAX ==========
const heroBg = document.querySelector('.hero-bg');
window.addEventListener('scroll', () => {
  if (!heroBg) return;
  const y = window.scrollY;
  if (y < window.innerHeight) {
    heroBg.style.transform = `scale(1.05) translateY(${y * 0.25}px)`;
  }
}, { passive: true });


// ========== KING GLOBAL CARD INTERACTIONS ==========
// Delegated handlers so they work on the homepage carousels, the collection
// product grid, and any cards Dawn re-renders after filtering / sorting.
(function () {
  if (window.__kingCardInteractions) return;
  window.__kingCardInteractions = true;

  var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

  /* ---- Quick add-to-cart (cart bag icon) ---- */
  function updateCartBadges() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        var badges = document.querySelectorAll('.cart-badge:not(.wl-badge)');
        for (var i = 0; i < badges.length; i++) {
          badges[i].textContent = c.item_count;
          badges[i].style.display = c.item_count > 0 ? '' : 'none';
        }
      })
      .catch(function () {});
  }

  function openCartDrawer(response) {
    var cart = document.querySelector('cart-drawer');
    if (cart && response && response.sections && response.sections['cart-drawer']) {
      try {
        var doc = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var current = document.querySelector('#CartDrawer');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        cart.classList.remove('is-empty');
        // Re-attach overlay click-to-close (lost when the inner HTML is replaced).
        var overlay = document.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof cart.close === 'function') {
          overlay.addEventListener('click', function () { cart.close(); });
        }
        if (typeof cart.open === 'function') { cart.open(); return true; }
      } catch (e) {}
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.add-cart[data-variant-id]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    var formData = new FormData();
    formData.append('id', id);
    formData.append('quantity', '1');
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          window.location = btn.getAttribute('href') || cartUrl;
          return;
        }
        var opened = openCartDrawer(response);
        updateCartBadges();
        if (!opened) { window.location = cartUrl; return; }
        btn.classList.add('wl-pop');
        setTimeout(function () { btn.classList.remove('wl-pop'); }, 300);
      })
      .catch(function () { window.location = cartUrl; })
      .finally(function () { btn.classList.remove('is-loading'); });
  }, true);

  /* ---- Colour swatch -> switch card image + active dot ---- */
  function activateSwatch(dot) {
    var card = dot.closest('.product, .d-card, .ltd-card');
    if (!card) return;
    var imgEl = card.querySelector('.product-img, .d-img, .ltd-img');
    var nameEl = card.querySelector('.swatch-name');
    var dots = dot.parentNode ? dot.parentNode.querySelectorAll('.swatch-dot') : [];
    for (var i = 0; i < dots.length; i++) dots[i].classList.remove('active');
    dot.classList.add('active');
    if (nameEl && dot.dataset.color) nameEl.textContent = dot.dataset.color;
    if (imgEl) {
      if (!imgEl.dataset.origBg) imgEl.dataset.origBg = imgEl.style.backgroundImage || '';
      if (dot.dataset.img) imgEl.style.backgroundImage = "url('" + dot.dataset.img + "')";
      else if (imgEl.dataset.origBg) imgEl.style.backgroundImage = imgEl.dataset.origBg;
    }
  }
  document.addEventListener('mouseover', function (e) {
    var dot = e.target.closest ? e.target.closest('.swatch-dot') : null;
    if (dot) activateSwatch(dot);
  });
  document.addEventListener('click', function (e) {
    var dot = e.target.closest ? e.target.closest('.swatch-dot') : null;
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    activateSwatch(dot);
  });

  /* ---- Size buttons -> mark active (don't follow the card link) ---- */
  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest ? e.target.closest('.sizes button') : null;
    if (!sizeBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var group = sizeBtn.parentNode;
    var btns = group ? group.querySelectorAll('button') : [];
    for (var i = 0; i < btns.length; i++) btns[i].classList.remove('active');
    sizeBtn.classList.add('active');
  });
})();
